exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".tutorial--container--2g5YXTjl {\r\n  text-align: center;\r\n  background-color: #F2F2F2;\r\n}\r\n\r\n.tutorial--header--1PAaCTSX {\r\n  font-weight: 400;\r\n}\r\n\r\n.tutorial--subHeader--1MvV2gEp {\r\n  font-weight: 300;\r\n}\r\n\r\n.tutorial--icon--1Cfpqu9V {\r\n  width: 60%;\r\n  max-width: 96px;\r\n  height: auto;\r\n}\r\n\r\n.tutorial--iconCol--1VkZIP2Z {\r\n  height: 128px;\r\n}\r\n", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/components/start/tutorial/tutorial.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,0BAA0B;CAC3B;;AAED;EACE,iBAAiB;CAClB;;AAED;EACE,iBAAiB;CAClB;;AAED;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;CACd;;AAED;EACE,cAAc;CACf","file":"tutorial.css","sourcesContent":[".container {\r\n  text-align: center;\r\n  background-color: #F2F2F2;\r\n}\r\n\r\n.header {\r\n  font-weight: 400;\r\n}\r\n\r\n.subHeader {\r\n  font-weight: 300;\r\n}\r\n\r\n.icon {\r\n  width: 60%;\r\n  max-width: 96px;\r\n  height: auto;\r\n}\r\n\r\n.iconCol {\r\n  height: 128px;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "tutorial--container--2g5YXTjl",
	"header": "tutorial--header--1PAaCTSX",
	"subHeader": "tutorial--subHeader--1MvV2gEp",
	"icon": "tutorial--icon--1Cfpqu9V",
	"iconCol": "tutorial--iconCol--1VkZIP2Z"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/components/start/tutorial/tutorial.css
// module id = 427
// module chunks = 0